class CustomAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.scrollYPosition = 0;
    this.isVisible = true;
    this.section = null;
  }

  connectedCallback() {
    if (!this.hasAttribute("data-show-on-scroll")) return;

    this.section = this.closest('[id^="shopify-section-"]');

    this.abortController = new AbortController();
    window.addEventListener("scroll", this.throttle(this.detectScrollDirection.bind(this)), {
      signal: this.abortController.signal,
      passive: true,
    });

    if (window.scrollY > 50) {
      this.isVisible = false;
      this.hideSticky();
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  hideSticky() {
    if (this.section) {
      this.section.classList.add("sticky-hidden");
      document.documentElement.style.setProperty("--custom-announcement-bar-is-sticky", "0");
    }
  }

  showSticky() {
    if (this.section) {
      this.section.classList.remove("sticky-hidden");
      document.documentElement.style.setProperty("--custom-announcement-bar-is-sticky", "1");
    }
  }

  throttle(callback) {
    let requestId = null;
    let lastArgs;
    const later = (context) => () => {
      requestId = null;
      callback.apply(context, lastArgs);
    };
    const throttled = (...args) => {
      lastArgs = args;
      if (requestId === null) {
        requestId = requestAnimationFrame(later(this));
      }
    };
    return throttled;
  }

  detectScrollDirection() {
    const currentScrollY = Math.abs(window.scrollY);

    if (currentScrollY <= 50) {
      if (!this.isVisible) {
        this.isVisible = true;
        this.showSticky();
      }
      this.scrollYPosition = currentScrollY;
      return;
    }

    let isVisible;

    if (currentScrollY > this.scrollYPosition && currentScrollY - this.scrollYPosition > 50) {
      isVisible = false;
      this.scrollYPosition = currentScrollY;
    } else if (currentScrollY < this.scrollYPosition) {
      this.scrollYPosition = currentScrollY;
      isVisible = true;
    }

    if (isVisible !== undefined && isVisible !== this.isVisible) {
      this.isVisible = isVisible;
      isVisible ? this.showSticky() : this.hideSticky();
    }
  }
}

if (!customElements.get("custom-announcement-bar")) {
  customElements.define("custom-announcement-bar", CustomAnnouncementBar);
}
